import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useDebounce } from '../../hooks/useDebounce/useDebounce';

import { AutosaveFormProps } from './AutosaveForm.types';

export const AutosaveForm = <T extends Record<string, unknown>>({
  children,
  onSubmit,
  delay = 500,
  ...props
}: AutosaveFormProps<T>) => {
  const formMethods = useForm<T>(props);

  const watchAllFields = formMethods.watch();
  const debouncedWatch = useDebounce(watchAllFields, delay);

  useEffect(() => {
    onSubmit(debouncedWatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedWatch]);

  return (
    <FormProvider<T> {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)}>
        {typeof children === 'function' ? children(formMethods) : children}
      </form>
    </FormProvider>
  );
};
